import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';
import MainArticle from './MainArticle.js';
import SmallArticle from './SmallArticle.js';
 
export default function ListMainArticle() {

  const jsonUrl = variables.basename_url +'updates/index/Coinsinsight_HomeEn_TrendingNews.json';
    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
     
 
  
    async function refda() {  
                 //  To Show or Hidden Header And Footer
                 document.getElementById('English_Header').hidden = false;
                 document.getElementById('English_Footer').hidden = false;
                 //
      setNisLoading(true);
   
      Get_Data();
     
    }

      const [JsonArray, setJsonArray] = React.useState([]);
 


      async function Get_Data(){
     
        JsonArray.splice(0);  //to clear All data in your page
  
       setNisLoading(true);
    
       axios.get(jsonUrl)  

             .then(function (response) {
             setNisLoading( false);
  
            
              
         
  
             for (let i = 10; i <= 13 && i < response.data.length; i++) {
             
              JsonArray.push({
            
                news_title: response.data[i].news_title,
                news_date:response.data[i].news_date,
                image: response.data[i].image  ,
                link:response.data[i].link,
                Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,

               Category:response.data[i].Category,
              })
              }
        })      
       }
         
    
     
      
      
   
   
      useEffect(() => {
       
       
        setNisLoading(true);
   
        refda();
           },[] )





            return (
          <>


 
 
<section className="post-news-2-area">
        <div className="container custom-container">
          <div className="row ">
 
 
            <div className="col-lg-6  ">
              <div className="post_gallery_play post_gallery_play-2 mt-40">
               {/* Main Article Here  */}
              <MainArticle/>
                 
              </div>
            </div>
            
            <div className="col-lg-3 col-md-5">
              <div className="post-news-list mt-40">
           
              
              {JsonArray.map(da=>     
  
  <div key= {da.news_title}  > 
              
                <div className="gallery_item populer_item-style">
                  <div className="gallery_item_thumb">
                    <a href={da.link}>
                    <img  className='MostView-Img' src={da.image} alt="gallery" />
                    </a>
                  </div>
                
                
                  <div className="gallery_item_content">
                    <h4 className="title"><a href={da.Link}>{da.news_title}</a></h4>
                    <span>{da.Category}</span>
                  </div>
                
                
                </div>


              </div>
                )}

 
                </div>

            </div>
          

       

            <div className="col-lg-3 col-md-6">
      {/* Small Article here */}
      <SmallArticle/>
            </div>
          </div>
        </div>
      </section>

  
         </>
        );
    }


  
